import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import { AuthProvider } from './auth/AuthContext'
import { LanguageProvider } from './shared/LanguageContext'
import TokenAuth from './auth/TokenAuth'
import ProtectedRoute from './auth/ProtectedRoute'
import IntakeForm from './intake/IntakeForm'

import ParentLayout from './parent/ParentLayout'
import StudentLayout from './student/StudentLayout'
import TaLayout from './ta/TaLayout'
import OfficeHours from './officeHours/OfficeHours'

import './styles/portal.css'

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
          <Routes>
            {/* Root route — if ?token= is present, show TokenAuth directly */}
            <Route path="/" element={<TokenAuth />} />
            {/* Path-based token — WeChat favorites preserve paths but strip query params */}
            <Route path="/t/:token" element={<TokenAuth />} />
            {/* Auth route — token validation */}
            <Route path="/auth" element={<TokenAuth />} />
            <Route path="/intake" element={<IntakeForm />} />

            <Route
              path="/office-hours"
              element={
                <ProtectedRoute allowedUserType="parent" authDestination="office-hours">
                  <OfficeHours />
                </ProtectedRoute>
              }
            />

            {/* Parent portal — single page */}
            <Route
              path="/parent"
              element={
                <ProtectedRoute allowedUserType="parent">
                  <ParentLayout />
                </ProtectedRoute>
              }
            />

            {/* Student portal — single page */}
            <Route
              path="/student"
              element={
                <ProtectedRoute allowedUserType="student" allowedRole="student">
                  <StudentLayout />
                </ProtectedRoute>
              }
            />

            <Route
              path="/ta"
              element={
                <ProtectedRoute allowedUserType="student" allowedRole="ta">
                  <TaLayout />
                </ProtectedRoute>
              }
            />

            {/* Catch-all: redirect to auth */}
            <Route path="*" element={<Navigate to="/auth" replace />} />
          </Routes>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)
